<div class="d-flex flex-column">
  <span
    class="small-title"> {{'proposalDetails.createOfferTab.fileUploadSection.title'|translate}}</span>
  <div class="d-flex field-container">
    <app-upload
      [uploadLocation]="UploadLocation.PROPOSALINFORMATION"
      (uploadInProgress)="sendUploadStatus($event)"
      (updateAttachedFilesInParent)="attachFiles($event)"
      class="w-100"
    ></app-upload>
  </div>
</div>
